import { render, staticRenderFns } from "./contentManageBK.vue?vue&type=template&id=56f43500&scoped=true"
import script from "./contentManageBK.vue?vue&type=script&lang=js"
export * from "./contentManageBK.vue?vue&type=script&lang=js"
import style0 from "./contentManageBK.vue?vue&type=style&index=0&id=56f43500&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f43500",
  null
  
)

export default component.exports